import settings from './settings.json'

const getRequiredItemFields = type => {
	return settings[type].itemFields
		.filter(field => field.required)
		.map(field => field.name)
}

export default getRequiredItemFields
